.search {
  position: relative;
  min-width: 0;
  grid-column: 1;
  display: grid;
  gap: var(--space-1);
}
.label {
  padding-left: 2px;
}

.field {
  position: relative;
  display: flex;
  align-items: center;
  border-bottom: 1.5px solid var(--ink);
  transition: border-color var(--duration-fast) var(--ease-out);
}

.field:focus-within {
  border-color: var(--accent);
}
.icon {
  color: var(--ink-subtle);
  flex: none;
}

.input {
  flex: 1;
  min-width: 0;
  min-height: 44px;
  padding: 0 var(--space-2);
  border: 0;
  background: none;
  font: 600 var(--text-2xl) / 1.1 var(--font-display);
  letter-spacing: -0.015em;
  outline: none;
}

.input::placeholder {
  color: var(--ink-subtle);
  font-weight: 400;
  font-size: var(--text-lg);
}

.clear {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border: 0;
  background: none;
  color: var(--ink-muted);
  border-radius: var(--radius-m);
}

.clear:hover {
  background: var(--surface-sunken);
}

.popover {
  position: absolute;
  z-index: var(--z-overlay);
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: var(--surface);
  border: 1px solid var(--rule-strong);
  box-shadow: 0 18px 36px -24px color-mix(in oklch, var(--ink) 55%, transparent);
  max-height: min(60dvh, 360px);
  overflow-y: auto;
  animation: pop var(--duration-fast) var(--ease-out);
}

@keyframes pop {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
}

.popover[hidden] {
  display: none;
}
.groupLabel {
  padding: var(--space-3) var(--space-3) var(--space-1);
}
.list {
  margin: 0;
  padding: var(--space-1) 0;
  list-style: none;
}

.option {
  display: flex;
  gap: var(--space-3);
  align-items: center;
  min-height: 48px;
  padding: var(--space-2) var(--space-3);
  cursor: pointer;
}

.option[aria-selected="true"] {
  background: var(--ink);
  color: var(--surface);
}

.optIcon {
  color: var(--ink-subtle);
  flex: none;
}
.optText {
  display: grid;
  min-width: 0;
}
.optName {
  font-weight: 550;
}
.optName mark {
  background: none;
  color: inherit;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-decoration-color: var(--accent);
  text-underline-offset: 3px;
}
.optDetail {
  font-size: var(--text-sm);
  color: var(--ink-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status:not(:empty) {
  padding: var(--space-3);
  font-size: var(--text-sm);
  color: var(--ink-muted);
}
.error {
  color: var(--danger);
}

.option[aria-selected="true"] .optDetail,
.option[aria-selected="true"] .optIcon {
  color: color-mix(in oklch, var(--surface) 72%, transparent);
}
